import React from 'react'
import './Title.css';

function Title() {
    return (
        <div className="title_container">
            <span className="title_name">
                10,000 Hour Rule
            </span>
        </div>
    )
}

export default Title
